import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { COMMA,ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { IrisService } from '../shared/iris.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  tagCtrl = new FormControl();
  filteredTag: Observable<string[]>;
  Tags: string[] = [];
  allTag: string[] = [];
  placeholder = "home.searchplaceholder";
  tiles: any[];
  links: any[];

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private translate: TranslateService,
    private irisSrv: IrisService,
    private router: Router,
    ) {
    console.log('dashboard constructor');
    this.tiles = environment.tiles;
    this.links = environment.links;
    this.allTag = environment.tags;
    
    this.irisSrv.resetIndex();

    this.filteredTag = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => tag ? this._filter(tag) : this.allTag.slice())
    );
   }

  ngOnInit() { }

  add(event: MatChipInputEvent): void {
    if (this.Tags.length >= 10) {
      alert('最大10個まで同時に検索可能です。');
      return;
    }

    const input = event.input;
    const value = event.value;

    // Add our tag
    if ((value || '').trim()) {
      this.Tags.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.tagCtrl.setValue(null);
  }

  remove(tag: string): void {
    const index = this.Tags.indexOf(tag);

    if (index >= 0) {
      this.Tags.splice(index, 1);
    }

    // add to candidate
    this.allTag.push(tag);
    this.tagCtrl.setValue(null);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.Tags.length >= 10) {
      alert('同時に検索可能なキーワードは最大10個までです。');
      return;
    }

    // remove from candidate
    const index = this.allTag.indexOf(event.option.value);
    if (index >= 0) {
      this.allTag.splice(index, 1);
    }

    this.Tags.push(event.option.value);
    this.tagInput.nativeElement.value = '';
    this.tagCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allTag.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  public onClick() {
    if (this.Tags.length == 0) {
      alert('キーワードを選択してください。');
      return;
    }
    let options: string[] = [];
    options = this.Tags;
    console.log(options);

    this.irisSrv.activeRoot();
    this.router.navigate(['searchedboard'], { queryParams: { type: 'search.type_article', options:  options.toString() } });
  }

  public onKeydown(event: KeyboardEvent) {
    if (event.code == 'Enter' &&
        event.isComposing == false) {
      this.onClick();
    }
  }

  cardStyle(color: string) {
    return {
        'box-shadow': `2px 2px 2px 1px ${color}, 2px -2px 2px 1px ${color}, -2px 2px 2px 1px ${color}, -2px -2px 2px 1px ${color};`,
    };
  }
}